var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortUnsortChange = function SvgSortUnsortChange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "sort-arrow"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3020_11008",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3020_11008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.80717 7.86649C5.7977 7.91405 5.79297 7.96318 5.79297 8.0139C5.79297 8.21759 5.86936 8.39351 6.02214 8.54167C6.17029 8.69444 6.34621 8.77083 6.54991 8.77083C6.60062 8.77083 6.64976 8.7661 6.69731 8.75663L5.80717 7.86649ZM8.7513 10.8106V12.25C8.7513 12.4625 8.82422 12.6406 8.97005 12.7844C9.11589 12.9281 9.29443 13 9.5057 13C9.71695 13 9.89403 12.9281 10.0369 12.7844C10.1665 12.6541 10.2373 12.4955 10.2494 12.3087L8.7513 10.8106ZM13.7513 15.8106V17.125L12.1055 15.4583C11.9527 15.3056 11.7756 15.2292 11.5742 15.2292C11.3728 15.2292 11.1957 15.3022 11.043 15.4484C10.8902 15.6078 10.8103 15.7885 10.8034 15.9905C10.7964 16.1925 10.8694 16.3693 11.0221 16.5208L13.9805 19.4792C14.0499 19.5486 14.1284 19.6007 14.2159 19.6354C14.3034 19.6701 14.3971 19.6875 14.4971 19.6875C14.5971 19.6875 14.6909 19.6701 14.7784 19.6354C14.8659 19.6007 14.9471 19.5486 15.0221 19.4792L16.221 18.2803L13.7513 15.8106ZM18.1954 16.1334C18.2049 16.0859 18.2096 16.0368 18.2096 15.9861C18.2096 15.7824 18.1332 15.6065 17.9805 15.4583C17.8323 15.3056 17.6564 15.2292 17.4527 15.2292C17.402 15.2292 17.3529 15.2339 17.3054 15.2434L18.1954 16.1334ZM15.2513 13.1893L13.7532 11.6912C13.7653 11.5044 13.8361 11.3459 13.9657 11.2156C14.1086 11.0719 14.2857 11 14.4969 11C14.7082 11 14.8867 11.0719 15.0326 11.2156C15.1784 11.3594 15.2513 11.5375 15.2513 11.75V13.1893ZM10.2513 8.1893L7.78165 5.71965L8.98047 4.52083C9.05547 4.45139 9.13672 4.39931 9.22422 4.36458C9.31172 4.32986 9.40547 4.3125 9.50547 4.3125C9.60547 4.3125 9.69922 4.32986 9.78672 4.36458C9.87422 4.39931 9.95269 4.45139 10.0221 4.52083L12.9805 7.47917C13.1332 7.63194 13.2096 7.80556 13.2096 8C13.2096 8.19444 13.1332 8.37138 12.9805 8.53079C12.8277 8.67693 12.6506 8.75 12.4492 8.75C12.2478 8.75 12.0707 8.67361 11.918 8.52083L10.2513 6.875V8.1893Z",
    fill: "#33445E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 6,
    y: 5,
    width: 19.1355,
    height: 1.5,
    rx: 0.75,
    transform: "rotate(45 6 5)",
    fill: "#33445E"
  })))));
};
export default SvgSortUnsortChange;